<div class="edit-payment-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <h2 class="dialog-title">Edit a Payment</h2>

    <button mat-icon-button aria-label="Close" (click)="cancel()" [disabled]="isSubmitting">

      <span class="svg-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M18.2197 4.71967L4.71967 18.2197C4.57902 18.3603 4.5 18.5511 4.5 18.75C4.5 18.9489 4.57902 19.1397 4.71967 19.2803C4.86032 19.421 5.05109 19.5 5.25 19.5C5.44891 19.5 5.63968 19.421 5.78033 19.2803L19.2803 5.78033C19.421 5.63968 19.5 5.44891 19.5 5.25C19.5 5.05109 19.421 4.86032 19.2803 4.71967C19.1397 4.57902 18.9489 4.5 18.75 4.5C18.5511 4.5 18.3603 4.57902 18.2197 4.71967Z"
            fill="#04304B" />
            <path
              d="M5.78033 4.71967C5.63968 4.57902 5.44891 4.5 5.25 4.5C5.05109 4.5 4.86032 4.57902 4.71967 4.71967C4.57902 4.86032 4.5 5.05109 4.5 5.25C4.5 5.44891 4.57902 5.63968 4.71967 5.78033L18.2197 19.2803C18.3603 19.421 18.5511 19.5 18.75 19.5C18.9489 19.5 19.1397 19.421 19.2803 19.2803C19.421 19.1397 19.5 18.9489 19.5 18.75C19.5 18.5511 19.421 18.3603 19.2803 18.2197L5.78033 4.71967Z"
              fill="#04304B" />
            </svg>
          </span>
        </button>
      </div>

      <!-- Dialog Content -->
      <div class="dialog-body">
        <div class="dialog-content">

          <!-- Customer Information Section -->
          <div class="customer-info">
            <h3 class="section-title">Customer Information</h3>

            <div class="info-row">
              <span class="label">Transaction ID</span>
              <span class="value">{{ data.transaction.id }}</span>
            </div>

            <div class="info-row">
              <span class="label">Name</span>
              <span class="value">{{ fullName }}</span>
            </div>

            <div class="info-row">
              <span class="label">Business Name</span>
              <span class="value">{{ data.transaction.buyer_company }}</span>
            </div>

            <div class="info-row">
              <span class="label">Amount Due</span>
              <span class="value">{{ data.transaction.current_balance | currency }}</span>
            </div>

            <div class="info-row">
              <span class="label">Due By</span>
              <span class="value">{{ data.transaction.due_date | date: 'MM/dd/yyyy' }}</span>
            </div>
          </div>

          <!-- Payment Actions Section -->
          <div class="payment-actions">
            <h3 class="section-title">Payment Actions</h3>

            <!-- Payment Method Selection -->
            <div class="action-row">
              <label for="wallet-select">Payment Method</label>
              <mat-form-field appearance="fill" class="full-width">
                <mat-select id="wallet-select" [(value)]="selectedWallet">
                  @for (wallet of wallets; track wallet) {
                    <mat-option [value]="wallet">
                      {{ wallet.nickname }}
                    </mat-option>
                  }
                </mat-select>

                @if (wallets.length === 0) {
                  <mat-hint>No saved bank accounts available. Please add a bank account first</mat-hint>
                }
                @if (wallets.length >= 1) {
                  <mat-hint>Select a bank account to make the payment from</mat-hint>
                }
              </mat-form-field>
            </div>

            <!-- Amount to Pay Input -->
            <div class="action-row">
              <label for="amount-to-pay">Amount To Pay</label>
              <mat-form-field appearance="fill" class="full-width">
                <span matPrefix>&nbsp;$</span>
                <input matInput type="text" id="amount-to-pay" required
                  [appMax]="data.transaction.current_balance" [appMin]=".01" mask="separator.2"
                  [thousandSeparator]="','" [(ngModel)]="formPayment.transaction_amount" #amountToPayField="ngModel">

                  <!-- Error Messages for Amount -->
                  @if (amountToPayField.errors?.['required']) {
                    <mat-error>Amount to pay is required.</mat-error>
                  }
                  @if (amountToPayField.errors?.['max']) {
                    <mat-error>Amount to pay cannot exceed the remaining amount</mat-error>
                  }
                  @if (amountToPayField.errors?.['min']) {
                    <mat-error>Amount to pay must be at least $0.01</mat-error>
                  }
                </mat-form-field>
              </div>

              <!-- Payment Date Selection -->
              <div class="action-row">
                <label for="payment-date">Payment Date</label>
                <mat-form-field appearance="fill" class="full-width">
                  <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <input id="payment-date" [min]="today" matInput [matDatepicker]="picker"
                    [(ngModel)]="formPayment.effective_date" required #paymentDateField="ngModel">

                    <!-- Error Messages for Payment Date -->
                    @if (paymentDateField.errors?.['matDatepickerMin']) {
                      <mat-error>Payment date cannot be in the past.</mat-error>
                    }
                    @if (paymentDateField.errors?.['required']) {
                      <mat-error>Payment date is required.</mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            </div>

            <!-- Dialog Footer with Submit Button -->
            <div class="dialog-footer">
              <p class="authorization-text">
                I authorize Transend to initiate a one-time electronic funds transfer from my bank
                listed above in the amount and on the date specified.
              </p>

              <div class="action-buttons">
                <button mat-raised-button color="primary" class="submit-btn" (click)="onSubmitEdit()"
                  [disabled]="isSubmitting || amountToPayField.invalid || paymentDateField.invalid">

                  @if (isSubmitting) {
                    <mat-spinner [diameter]="20" color="accent"></mat-spinner>
                  }

                  @if (!isSubmitting) {
                    <span>Submit Payment</span>
                  }
                </button>
              </div>
            </div>
          </div>
        </div>